import { writable } from "svelte/store";
import type { User } from "./walletapi";
import { service } from "./services";

// Store para usuarios sin asignar
export const unassignedUsers = writable<User[]>([]);

const TOKEN_STORAGE_KEY = "token";
function GetSessionToken() {
    const token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
    return token ? token : undefined;
}

export async function RefreshUnassignedUsers() {
    const token = GetSessionToken();
    if (!token) {
        return;
    }

    try {
        const response = await service.walletapi.unassignedUsers({
            Token: token
        });

        if (!response.Success || !response.Data) {
            return;
        }

        // Actualizar el store con los nuevos usuarios
        unassignedUsers.set(response.Data);
        
    } catch (error) {
       
    }
}
